<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe" />
          {{$t('title')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{$t('search')}}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting" v-if="['tech', 'owner', 'admin'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus" />&nbsp;{{$t('create')}}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{$t('found', [itemCount])}}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{$t('code')}}</div>
            <div class="col-lg-7">{{$t('subject')}}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{$t('code')}}: </b>
              <span>{{item.code}}</span>
            </div>
            <div class="col-lg-7">
              <b class="c-smart-table__label">{{$t('subject')}}: </b>
              <span v-if="item.title">{{item.title}}</span>
            </div>
            <div class="col-lg-3 text-center">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="detail(item)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="eye" />&nbsp;{{$t('detail')}}
                    </button>
                    <button @click="update(item._id)" type="button"
                            v-if="['tech', 'owner', 'admin'].includes($store.state.user.role)"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit" />&nbsp;{{$t('edit')}}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1"
                            v-if="['tech', 'owner', 'admin'].includes($store.state.user.role)">
                      <font-awesome-icon icon="trash" />&nbsp;{{$t('delete')}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{$t('notFoundCreate')}}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{$t('notFoundSearch')}}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{$t('found', [itemCount])}}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('code')" :model="formModel" attribute="code" :errors="formErrors"></form-input>
      <form-input :label="$t('subject')" :model="formModel" attribute="title" :errors="formErrors">
      </form-input>
      <b-form-group :label="$t('desc')">
        <vue-editor style="height: 500px; margin-bottom: 82px;" v-model="formModel.desc"></vue-editor>
      </b-form-group>
      <b-form-group :label="$t('solve')">
        <vue-editor style="height: 500px; margin-bottom: 82px;" v-model="formModel.solve"></vue-editor>
      </b-form-group>
    </b-modal>
    <b-modal size="lg" v-model="showDetail" :title="$t('detail')" no-close-on-backdrop no-enforce-focus>
      <p><b>{{$t('code')}}</b>: {{formModel.code}}</p>
      <p><b>{{$t('subject')}}</b>: {{formModel.title}}</p>
      <div v-if="formModel.desc">
        <b>{{$t('desc')}}</b>:
        <vue-editor class="mt-2" disabled :editorOptions="editorOptions" style="overflow: hidden;" v-model="formModel.desc"></vue-editor>
      </div>
      <div class="mt-4" v-if="formModel.solve">
        <b>{{$t('solve')}}</b>:
        <vue-editor class="mt-2" disabled :editorOptions="editorOptions" style="overflow: hidden;" v-model="formModel.solve"></vue-editor>
      </div>
      <p class="mt-3" v-if="formModel.createdBy"><b>{{$t('createdBy')}}</b>: {{formModel.createdBy.name}}</p>
      <p><b>{{$t('updateTime')}}</b>: {{formModel.updateTime | moment('DD/MM/YYYY HH:mm:ss')}}</p>
      <template #modal-footer="{ ok }">
        <b-button size="md" variant="primary" @click="ok">Ok</b-button>
      </template>
    </b-modal>
  </main>
</template>
<script>
import List from '../mixins/List';
import CRUD from "../mixins/CRUD";
import { VueEditor } from 'vue2-editor';
export default {
  components: {VueEditor },
  mixins: [List, CRUD],
  data: function() {
    return {
      service: '/error',
      defaultFormModel: {},
      autoLoad: true,
      showDetail: false,
      editorDisabled: false,
      editorOptions: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Popular error',
        code: "Code",
        subject: "Subject",
        solve: "Solve",
        createdBy: "Created by"
      },
      vi: {
        title: 'Vấn đề thường gặp',
        code: "Mã",
        subject: "Tiêu đề",
        solve: "Giải quyết",
        createdBy: "Tạo bởi"
      }
    }
  },
  methods: {
    detail(item) {
      this.formModel = item;
      this.showDetail = true;
    }
  }
}
</script>